import React, { Fragment } from 'react';
import APWarningBox from 'legacy/src/utility/APWarningBox';
import { ADMIN_UNIT_OUTLINE as COPY } from 'chameleon/ui-stack/utilities/copy';
import SelectClasses from 'legacy-src/utility/ClassesSelector/SelectClasses.js';

const ShareContent = ({ isEmbeddedVideo }) => (
  <Fragment>
    <APWarningBox
      message={
        isEmbeddedVideo
          ? COPY.SHARE_VIDEO_RESOURCE_ALERT
          : COPY.SHARE_RESOURCE_ALERT
      }
    />
    {isEmbeddedVideo ? null : (
      <Fragment>
        <div className="text-gray-700 text-14 mx-4.6 my-4.2">
          Select who should see this resource in their AP Classroom Course
          Resources. You can adjust which classes can see this resource at any
          time.
        </div>
        <SelectClasses
          label="Select classes"
          selectionBox={
            <div className="my-8.4 mx-4.6 py-0.8 px-4.2 border border-dashed border-gray-400 bg-gray-100 text-gray-600 rounded-0.8">
              Classes appear here
            </div>
          }
        />
      </Fragment>
    )}
  </Fragment>
);

export default ShareContent;
